import React from 'react';
import Component from '../../_shared/components/component.js';
import { Link } from 'react-router-dom';
import BreadcrumbsContainer from '../../_shared/components/breadcrumbs-container.js';

export default class Posts extends Component {
  constructor(props) {
    super(...arguments);
    if(props.summaries.length == 0) {
      props.fetchSummaries(1);
    }
  }

  olderPosts() {
    this.props.fetchSummaries(this.props.pageNumber+1);
  }

  render() {
    return pug`
      div
        BreadcrumbsContainer
        each Summary in this.props.summaries
          article(key='summary-' + Summary.key())
            h1
              Link(to='/posts/' + Summary.key())= Summary.title()
            Summary
            p
              Link(to='/posts/' + Summary.key()) Read more…
        if this.props.moreSummariesAvailable
          p.older-posts
            a(href='#' onClick=this.olderPosts) Older posts…
    `;
  }
}
